import { render, staticRenderFns } from "./bigData9.vue?vue&type=template&id=00b66fdf&scoped=true&"
import script from "./bigData9.vue?vue&type=script&lang=js&"
export * from "./bigData9.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b66fdf",
  null
  
)

export default component.exports